import React, { useState } from "react";
import classnames from "classnames";
import { useSelector } from "react-redux";
import { TEMPLATE_COLOR_UID_MAP } from "utils/constants/template";
import { getIconForUID } from "components/FormerEditor/utils";
import { COLORS } from "utils/styles";
import { useFormikContext } from "formik";
import isEqual from "lodash/isEqual";
import { useHoverProps } from "utils/hooks";

const ProductTemplateOption = ({
  title,
  uid,
  description,
  isSelected,
  onClick,
  data,
  isLast,
  isFirst
}) => {
  const [hover, setHover] = useState(false);
  const hoverProps = useHoverProps({ hover, setHover });
  const Icon = getIconForUID(uid);
  const CheckmarkIcon = getIconForUID("checkmark");
  const containerProps = {
    className: classnames(
      "pt3 ph3 pb3 bl br flex flex-row bb hairline-1 pb3 pointer",
      {
        "bt br--top br2": isFirst,
        "bg-content--secondary": hover,
        "bg-white": !hover,
        "br--bottom br2": isLast
      }
    ),
    onClick,
    ...hoverProps
  };
  const color = TEMPLATE_COLOR_UID_MAP[uid] || COLORS.primary;

  return (
    <li {...containerProps}>
      {Icon && (
        <div
          style={{ height: 28, width: 28 }}
          className={
            "flex items-center justify-center bg-content--secondary br2 icon--boundary flex-shrink-0"
          }
        >
          <Icon size={16} color="#ffffff" />
          <style jsx>{`
            .icon--boundary {
              background-color: ${color};
            }
          `}</style>
        </div>
      )}
      <div className="flex flex-column w-100">
        <div
          className={classnames("flex flex-column pl3", {
            "o-40": !isSelected
          })}
        >
          <div className="flex flex-row justify-between">
            <div className={"fw5 f5"}>{title}</div>
            <CheckmarkIcon
              style={{ height: 18, width: 18 }}
              color={isSelected ? COLORS.blue : COLORS.deselected}
            />
          </div>
          <div className="f6 pt2 lh-copy">{description}</div>
        </div>
      </div>
    </li>
  );
};

const ProductTemplatePickerList = () => {
  const templates = useSelector((state) =>
    state.getIn(["app", "data", "templates"]).toJS()
  );
  const { values, setFieldValue } = useFormikContext();
  const products = values.products;

  const productTemplates = templates.products;

  const options = productTemplates.map((template, templateIx) => {
    const isFirst = !templateIx;
    const isLast = productTemplates.length - 1 === templateIx;

    const templateProducts = template.data;

    const templateIds = templateProducts.map(({ uuid }) => uuid);
    const productIds = products.map(({ uuid }) => uuid);
    const isSelected = isEqual(templateIds, productIds);

    const optionProps = {
      ...template,
      isLast,
      isFirst,
      onClick: () => {
        if (isSelected) {
          setFieldValue("products", []);
        } else {
          setFieldValue("products", templateProducts);
        }
      }
    };

    optionProps.isSelected = isSelected;

    return <ProductTemplateOption key={templateIx} {...optionProps} />;
  });

  return <ul className="ma0 pa0 list bg-white pa3">{options}</ul>;
};

export default ProductTemplatePickerList;
